import { getSelectedOptions } from '../pages/ClientConnectV2/helpers/clientConnectSurveyQuestions';
import { isGridspotQuestion } from './gridspot';
import { normalizeId } from '../pages/ClientConnectV2/survey/surveyPreviewUtils';

/** True when the selected choice option has finish_survey (Normal radio/rating/emoji/dropdown). */
export function choiceValueFinishesSurvey(question, value) {
  if (value == null || value === '' || isGridspotQuestion(question)) {
    return false;
  }

  return getSelectedOptions(question, value).some(
    (option) => option?.finish_survey === true,
  );
}

/** Question ids after `questionId` in the original survey.questions order. */
export function getQuestionIdsAfter(allQuestions, questionId) {
  const questions = allQuestions || [];
  const currentIndex = questions.findIndex(
    (question) => normalizeId(question?._id) === normalizeId(questionId),
  );

  if (currentIndex < 0) {
    return [];
  }

  return questions
    .slice(currentIndex + 1)
    .map((question) => question?._id)
    .filter((id) => id != null && id !== '');
}

/**
 * Keeps questions at or before the finish question (by original array index).
 * Used so hide/route visibility still applies, but nothing after early finish remains.
 */
export function filterQuestionsThroughFinish(allQuestions, visibleQuestions, finishQuestionId) {
  if (finishQuestionId == null || finishQuestionId === '') {
    return visibleQuestions || [];
  }

  const finishIndex = (allQuestions || []).findIndex(
    (question) => normalizeId(question?._id) === normalizeId(finishQuestionId),
  );

  if (finishIndex < 0) {
    return visibleQuestions || [];
  }

  return (visibleQuestions || []).filter((question) => {
    const index = (allQuestions || []).findIndex(
      (candidate) => normalizeId(candidate?._id) === normalizeId(question?._id),
    );
    return index >= 0 && index <= finishIndex;
  });
}

export function omitAnswersByQuestionIds(answers, questionIds) {
  if (!answers) {
    return {};
  }

  const omitKeys = new Set();
  (questionIds || []).forEach((id) => {
    omitKeys.add(normalizeId(id));
    omitKeys.add(id);
  });

  return Object.fromEntries(
    Object.entries(answers).filter(([key]) => !omitKeys.has(key) && !omitKeys.has(normalizeId(key))),
  );
}
